import styled from 'styled-components'
import {H5, Paragraph} from '@modifi/ui'
import {adminUploadFormComponents} from '@modifi/plugin-documents'

export const StyledH5 = styled(H5)`
  text-align: center;
`

export const StyledParagraph = styled(Paragraph)`
  text-align: center;
`

export const FileUploadContainerWithSpacing = styled(adminUploadFormComponents.FileUploadContainer)`
  margin-bottom: 24px;

  > label {
    display: none;
  }
`
